import React, { useState, useEffect } from 'react';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import serviceService from '../services/serviceService';
import SkeletonLoader from './SkeletonLoader';
import EmptyState from './EmptyState';
import PageHeader from './PageHeader';
import './../pages/Dashboard.css';

const ServicesManager = () => {
  const initialFormState = { nome_servico: '', descricao: '', preco: '', imagem: '', duracao_minutos: 30 };
  
  const [services, setServices] = useState([]);
  const [formState, setFormState] = useState(initialFormState);
  const [editingId, setEditingId] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const data = await serviceService.getServices();
      setServices(data);
    } catch (error) {
      console.error("Erro ao buscar serviços", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState(prev => ({ ...prev, [name]: value }));
  };
  
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let finalServiceData = { ...formState };
    try {
      if (selectedFile) {
        setUploading(true);
        const imageUrl = await serviceService.uploadServiceImage(selectedFile);
        finalServiceData.imagem = imageUrl;
        setUploading(false);
      }
      
      if (editingId) {
        await serviceService.updateService(editingId, finalServiceData);
      } else {
        await serviceService.createService(finalServiceData);
      }
      fetchServices();
      resetForm();
    } catch (error) {
      //console.error("Erro ao salvar serviço", error);
      alert("Falha ao salvar o serviço.");
      setUploading(false);
    }
  };

  const handleEdit = (service) => {
    setEditingId(service.id);
    setFormState({
      nome_servico: service.nome_servico,
      descricao: service.descricao,
      preco: service.preco,
      imagem: service.imagem || '',
      duracao_minutos: service.duracao_minutos || 30
    });
    setSelectedFile(null);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Tem certeza que deseja deletar este serviço?")) {
      try {
        await serviceService.deleteService(id);
        fetchServices();
      } catch (error) {
        console.error("Erro ao deletar serviço", error);
      }
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setFormState(initialFormState);
    setSelectedFile(null);
    if (document.getElementById('file-input-services')) {
      document.getElementById('file-input-services').value = null;
    }
  };

 return (
    // 1. O container principal da página
    <div className="page-container"> 
      {/* 2. Adiciona o cabeçalho padrão da página */}
      <PageHeader title="Meus Serviços" />

      {/* 3. O layout de duas colunas para o conteúdo */}
      <div className="content-area">
        
        {/* Card do formulário (estava correto) */}
        <div className="card">
          <h3>{editingId ? 'Editar Serviço' : 'Adicionar Novo Serviço'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="nome_servico">Nome do Serviço</label>
              <input id="nome_servico" name="nome_servico" className="form-input" value={formState.nome_servico} onChange={handleInputChange} placeholder="ex: Corte Masculino" required />
            </div>
            <div className="form-group">
              <label htmlFor="preco">Preço (R$)</label>
              <input id="preco" name="preco" type="number" step="0.01" className="form-input" value={formState.preco} onChange={handleInputChange} placeholder="ex: 30.00" required />
            </div>
            <div className="form-group">
              <label htmlFor="duracao_minutos">Duração (minutos)</label>
              <input id="duracao_minutos" name="duracao_minutos" type="number" className="form-input" value={formState.duracao_minutos} onChange={handleInputChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="descricao">Descrição</label>
              <textarea id="descricao" name="descricao" className="form-input" value={formState.descricao} onChange={handleInputChange}></textarea>
            </div>
            <div className="form-group">
              <label htmlFor="file-input-services">Imagem do Serviço</label>
              <input id="file-input-services" type="file" className="form-input" onChange={handleFileChange} accept="image/png, image/jpeg" />
              {formState.imagem && !selectedFile && <img src={formState.imagem} alt="Prévia" className="image-preview" />}
            </div>
            <div className="form-buttons">
              <button type="submit" className="btn btn-primary" disabled={uploading}>
                {uploading ? 'Enviando...' : (editingId ? 'Salvar Alterações' : 'Adicionar Serviço')}
              </button>
              {editingId && <button type="button" className="btn btn-secondary" onClick={resetForm}>Cancelar</button>}
            </div>
          </form>
        </div>
        
        {/* Card da listagem (aqui estava o erro) */}
        <div className="card"> {/* <-- CORREÇÃO: Deve ser a classe .card */}
          <h3>Serviços Cadastrados</h3>
          {loading ? (
            <div><SkeletonLoader /><SkeletonLoader /><SkeletonLoader /></div>
          ) : services.length > 0 ? (
            <ul className="service-list">
              {services.map(service => (
                <li key={service.id}>
                  {service.imagem && <img src={service.imagem} alt={service.nome_servico} className="service-thumbnail" />}
                  <div className="service-info">
                    <strong>{service.nome_servico}</strong> - <span>R$ {service.preco}</span>
                    <p>{service.descricao || `Duração: ${service.duracao_minutos} min`}</p>
                  </div>
                  <div className="service-actions">
                    <button className="btn-icon" onClick={() => handleEdit(service)}><FaPencilAlt /></button>
                    <button className="btn-icon btn-danger-icon" onClick={() => handleDelete(service.id)}><FaTrash /></button>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <EmptyState message="Você ainda não cadastrou nenhum serviço."/>
          )}
        </div>

      </div>
    </div>
  );
};

export default ServicesManager;